<template>
  <div>
    <div
      class="pa-3"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <v-layout wrap justify-space-between>
        <v-flex xs12 sm6 style="display: flex; align-items: center">
          <h1>Dine In District Setting</h1>
          <v-divider vertical class="mx-3"></v-divider>
          <v-btn color="primary" class="black--text" round @click="toAdd()"
            ><v-icon class="pr-2">add</v-icon>New district</v-btn
          ></v-flex
        >
        <v-flex xs12 sm3>
          <v-autocomplete
            prepend-icon="mdi-filter"
            label="Province"
            :items="provinceData"
            item-value="province_id"
            item-text="province_name_en"
            hide-details
            clearable
            v-model="filterBy.province"
          ></v-autocomplete
        ></v-flex>
      </v-layout>
    </div>

    <v-card
      class="elevation-0 mt-3"
      style="border: 1.5px solid grey; border-radius: 10px; padding: 10px"
    >
      <v-data-table
        :headers="headers"
        :loading="isLoadingData"
        :items="filteredDistrictList"
        :rows-per-page-items="[10, 25, 50, 100]"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-center">
            <v-img :src="props.item.store_district_image" alt="" />
          </td>
          <td class="text-xs-center">
            {{ props.item.store_district_district.district_name_th }}
          </td>
          <td class="text-xs-center">
            {{ props.item.store_district_district.district_name_en }}
          </td>
          <td class="text-xs-center">
            {{
              showProvinceName(
                props.item.store_district_district.district_province
              )
            }}
          </td>
          <!-- <td>
            <v-switch
              v-model="props.item.store_status"
              color="primary"
              @change="changeState(props.item.store_id)"
              hide-details
            ></v-switch>
          </td> -->
          <td class="text-xs-center">
            <v-btn icon @click="toEdit(props.item, props.index)">
              <v-icon color="info" size="34">mdi-pencil-circle</v-icon>
            </v-btn>
            <v-btn
              :loading="isDeleteID.includes(props.item.store_district_id)"
              icon
              @click="deleteStoreDistrict(props.item.store_district_id)"
            >
              <v-icon color="red" size="34">mdi-delete-circle</v-icon>
            </v-btn>
          </td>
        </template>

        <template slot="no-data">
          <div v-if="isLoadingData == true" class="text-xs-center">
            <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            Loading data ...
          </div>
          <div v-if="storeDistrictList.length == 0">No data available</div>
        </template>
      </v-data-table>
    </v-card>
    <formDistrictSetting
      @onSaved="onSubmitForm($event)"
      @onClosed="formDialog = false"
      :dialog="formDialog"
      :editedIndex="editedIndex"
      :selectedItem="selectedItem"
      :unAvailableDistrict="
        storeDistrictList.map((val) => val.store_district_district.district_id)
      "
    ></formDistrictSetting>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import formDistrictSetting from "@/components/back-office/DineIn/Setting/formDistrictSettingDialog.vue";
export default {
  data: () => ({
    formDialog: false,
    selectedItem: {},
    editedIndex: -1,
    isLoadingData: false,
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Image",
        align: "center",
        sortable: false,
      },
      {
        text: "Distict name TH",
        align: "center",
        sortable: false,
      },
      {
        text: "Distict name EN",
        align: "center",
        sortable: false,
      },
      {
        text: "Province",
        align: "center",
        sortable: false,
      },
      // {
      //   text: "Status",
      //   align: "center",
      //   value: "store_name_en",
      //   sortable: false,
      // },
      {
        text: "Action",
        align: "center",
        value: "",
        sortable: false,
      },
    ],
    storeDistrictList: [],
    filterBy: {
      province: undefined,
    },
    isDeleteID: [],
  }),
  components: {
    formDistrictSetting,
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    filteredDistrictList() {
      return this.storeDistrictList.filter(
        (val) =>
          val.store_district_district.district_province ==
            this.filterBy.province || this.filterBy.province == undefined
      );
    },
  },
  watch: {},

  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions({
      removeStoreDistrict: "fetchDineIn/removeStoreDistrict",
      fetchStoreDistrictList: "fetchDineIn/fetchStoreDistrictList",
      createStoreDistrictList: "fetchDineIn/createStoreDistrictList",
      updateStoreDistrictList: "fetchDineIn/updateStoreDistrictList",
    }),
    moment,
    async deleteStoreDistrict(storeDistrictID) {
      let result = await confirm("Are you sure to delete this district ? ");
      if (result == false) return;
      this.isDeleteID.push(storeDistrictID);
      await this.removeStoreDistrict(storeDistrictID);
      let index = this.isDeleteID.findIndex((val) => val == storeDistrictID);
      this.isDeleteID.splice(index, 1);
      let index2 = this.storeDistrictList.findIndex(
        (val) => val.store_district_id == storeDistrictID
      );
      this.storeDistrictList.splice(index2, 1);
    },
    showProvinceName(id) {
      let isFound = "";
      for (let i = 0; i < this.provinceData.length; i++) {
        if (this.provinceData[i].province_id == id) {
          isFound = this.provinceData[i].province_name_en;
        }
      }
      if (isFound != "") {
        return isFound;
      } else {
        return null;
      }
    },
    async fetchData() {
      this.isLoadingData = true;
      this.storeDistrictList = await this.fetchStoreDistrictList();
      this.isLoadingData = false;
    },
    toEdit(item, index) {
      this.editedIndex = index;
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.formDialog = true;
    },
    toAdd() {
      this.editedIndex = -1;
      this.formDialog = true;
    },
    async onSubmitForm(e) {
      if (this.editedIndex == -1) {
        let payload = {
          store_district_district_id: e.form.store_district_district_id,
          store_district_image: e.newImageSrc,
        };
        let result = await this.createStoreDistrictList(payload);
        e.done();
        if (result == false) return;
        this.storeDistrictList.push(result);
      } else {
        let payload = {
          store_district_id: e.form.store_district_id,
          store_district_district_id: e.form.store_district_district_id,
          newStoreDistrictImage: e.newImageSrc,
        };
        let result = await this.updateStoreDistrictList(payload);
        e.done();
        if (result == false) return;
        let index = this.storeDistrictList.findIndex(
          (val) => val.store_district_id == result.store_district_id
        );
        this.storeDistrictList.splice(index, 1, result);
      }
      this.formDialog = false;
    },
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}

.view-detail-btn {
  font-size: 13px;
  outline: none;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.edit-time-btn {
  font-size: 13px;
  outline: none;
  background-color: #2175f3;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.delete-btn {
  font-size: 13px;
  outline: none;
  background-color: red;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>
